import { CREATE_PACKAGE } from 'client/modules/packages/utils/tab-names';
import { UPDATE_TAB_NAME } from '../actions/current-tab';

const initialState = CREATE_PACKAGE;

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_TAB_NAME:
      return action.tabName || initialState;
    default:
      return state;
  }
}
